import TargetPositionComposition from "./TargetPositionComposition";
import CandidateCompetences from "./CandidateCompetences";
import CandidateMotivationFactors from "./CandidateMotivationFactors";
import AdeptAspectsSection from '../TalentMatchScoreComponents/AdeptAspectsSection';
import SalesStrengthsSection from '../TalentMatchScoreComponents/SalesStrengthsSection';
import TeamStrengthsSection from '../TalentMatchScoreComponents/TeamStrengthsSection';
import ScoreLine from "../reusableElementsComponents/ScoreLine";
import ExplanationTooltip from "../reusableElementsComponents/ExplanationTooltip";
import { Accordion } from "react-bootstrap";
import {getAONAssessmentLabelById} from '../../Utilities'
import "react-circular-progressbar/dist/styles.css";
import { t, lookups } from "../../content";

function TalentMatchScore({ candidateData, matchPercentage }) {
  const data = candidateData;
  const reasoningAndSkills = lookups.reasoningAndSkills;

  return (
    <>
      {data && (
        <div className="match-section">
          {data.target_position_competencies_distribution &&
            data.target_position_competencies_distribution.length > 0 && (
              <div className="white-box">
                <TargetPositionComposition
                  data={data}
                  matchPercentage={matchPercentage}
                />
              </div>
            )}

          {data?.team_strengths.length === 9 && <TeamStrengthsSection data={data} />}

          {data?.adept_aspects_points?.length === 15 && <AdeptAspectsSection data={data} />}

          <div className="row">
            <div className="col-6">
              <div className="competences-motivation-section">
                <CandidateCompetences data={data} />
              </div>
            </div>

            <div className="col-6">
              <div className="competences-motivation-section">
                <CandidateMotivationFactors data={data} />
              </div>
            </div>
          </div>

          {data?.sales_strengths?.competence?.length === 8 && <SalesStrengthsSection data={data} />}

          <div className="row">
            <div className="col-6" style={{marginBottom: "20px"}}>
              {Object.keys(candidateData?.skill_assessment).length !== 0 && (
                  <div className="assessments-section" id="boxStyleAssessment">
                    <div className="title">
                      <p className="m-0">
                        {t("talents.sections.reasoningAndSkills")}
                        <ExplanationTooltip>
                          {t("talents.help.reasoningAndSkills")}
                        </ExplanationTooltip>
                      </p>
                      <p className="xs grey">
                        {t("common.verifiedByAon")}
                      </p>
                    </div>
                    <div className="stats">
                      <Accordion>
                        {Object.entries(candidateData?.skill_assessment).map(([id, score], index) => {
                            const reasoningContent = reasoningAndSkills.find(
                              (item) => Number(item.id) === Number(id)
                            );
                            return (
                            <Accordion.Item eventKey={id} key={id}>
                              <Accordion.Header>
                                <div className="accordion-header-wrapper">
                                  <p className="mar-5 right s">{getAONAssessmentLabelById(parseInt(id))}</p>
                                  {index === 0 ? (
                                      <div style={{display: "flex", flexDirection: "column"}}>
                                        <div className="scoreline-div">
                                          <span className="grey-bar">{t("common.scale.low")}</span>
                                          <span className="grey-bar">{t("common.scale.average")}</span>
                                          <span className="grey-bar">{t("common.scale.high")}</span>
                                        </div>
                                        <ScoreLine val={Math.round((score / 100) * 10)}/>
                                      </div>
                                  ) : (
                                      <ScoreLine val={Math.round((score / 100) * 10)}/>
                                  )}
                                </div>
                              </Accordion.Header>
                              {reasoningContent?.description && (
                                <Accordion.Body>
                                  {reasoningContent.description}
                                </Accordion.Body>
                              )}
                            </Accordion.Item>
                            );
                        })}
                      </Accordion>
                    </div>
                  </div>
              )}
            </div>
            
          </div>
        </div>
      )}
    </>
  );
}

export default TalentMatchScore;
